module.exports = __webpack_public_path__ + "static/img/title_04@2x.5f34768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/title_04@2x.png
// module id = zMnz
// module chunks = 1